<template>
  <PdfPage :node="node">
    <PurchaseAndSale mode="pdf" :node="node"></PurchaseAndSale>
  </PdfPage>
</template>

<script>
import PdfPage from "@/pages/pdfFrontGenerator/components/PdfPage";
import UpDownCustomer from "@/pages/Result/ThreeYearResult/financialAnalysis/UpDownCustomer";
import PurchaseAndSale
  from "@/pages/Result/ThreeYearResult/financialAnalysis/purchaseAndSale/PurchaseAndSale";
import {getCompanyInfo} from "@/api/threeYears";

export default {
  name: "PurchaseAndSalePdf",
  props: {
    pageStartFrom: Number,
    orderStartFrom: Number,
    offset: Number
  },
  components: {
    PdfPage,
    PurchaseAndSale
  },
  data() {
    return {
      loaded: false,
      companyInfo: {}
    }
  },
  async mounted() {
    this.loaded = false
    await this.loadCompanyInfo();
    this.loaded = true
    this.$eventBus.$emit('appendToc', this.node)
  },
  methods: {
    async loadCompanyInfo() {
      const res = await getCompanyInfo({programId: this.$route.params.uuid})
      this.companyInfo = res.data
    },
  },
  computed: {
    /**
     * 可选的年份
     * @returns {(number|number)[]}
     */
    yearsOption() {
      if (!this.companyInfo.zq) {
        return []
      }
      const zq = parseInt(this.companyInfo.zq.replace("004"))
      const ret = [zq, zq - 1, zq - 2]
      return ret
    },
    node() {
      return {
        page: this.pageStartFrom + this.offset,
        orderNumber: this.orderStartFrom + this.offset,
        treeDataItem: {
          titleName: '购销分析',
          children: [
            {
              titleName: '购销金额波动',
            },
            {
              titleName: '购销品类对比',
            },
            {
              titleName: '采购品类',
              children: this.yearsOption.map(year => {
                return {titleName: `${year}年采购分析`}
              })
            },
            {
              titleName: '销售品类',
              children: this.yearsOption.map(year => {
                return {titleName: `${year}年销售分析`}
              })

            }
          ]
        },
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/pages/pdfFrontGenerator/pdf.styl"


.pdf-page-wrapper {
  padding 33px 0
}
</style>
